import { useViewportSize } from '@mantine/hooks'

import { util } from '@showrunner/codex'
import { schema } from '@showrunner/prose-schemas'

import { TimingPopover } from '#components/EditorToolbar/TimingPopover'
import { ButtonMode } from '#state'

import { useSnapshotData } from '../useSnapshotLandData'

interface SnapshotTimingPopoverProps {
  scriptId: string
  snapshotId: string
  readRate: number
  mode: ButtonMode
}

export function SnapshotTimingPopover(props: SnapshotTimingPopoverProps) {
  'use memo'

  const { height } = useViewportSize()

  const query = useSnapshotData({
    scriptId: props.scriptId,
    snapshotId: props.snapshotId,
  })

  if (!query.isSuccess || query.data.doc.attrs?.docType === 'screenplay') {
    return null
  }

  const timing = new util.ScriptBreakdown(
    schema.nodeFromJSON(query.data.doc),
    props.readRate,
  ).timing

  return (
    <TimingPopover mode={props.mode} height={height - 100} docTiming={timing} />
  )
}
